import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Retrieveyourdetails from "./ForgotPassword";
import { isAuthenticated } from "../helpers/authUtils";
//import LuminateLogo from "assets/images/JBU.png";
//import LuminateLogo from "assets/images/BACOHT.png";
// var LuminateLogo = "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  studentSignIn,
  updateUsermode,
} from "actions/Auth";
import { OSCOHTLogo } from "assets/images/image";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

class StudentSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      showPassword: false,
    };
  }
  componentDidMount() {
    this.props.updateUsermode("Student");
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/student/dashboard");
    }
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/student/dashboard");
    }
  }

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  render() {
    const { email, password, showPassword } = this.state;
    const { showMessage, loader, alertMessage } = this.props;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div
            className="app-logo-content d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#1E90FF",
              padding: "10px 15px 10px 10px", // Slightly more padding on the right
              borderRadius: "4px",
              // marginLeft: "-15px",
            }}
          >
            <Link className="logo-lg" to="../" title="Luminate">
              <img
                src={OSCOHTLogo}
                alt="OSCOHTLogo"
                title="OSCOHTLogo"
                className="img-fluid"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Student Login</h1>
              <h5
                className="d-flex align-items-center justify-content-center p-1"
                style={{ color: "#1E90FF" }}
              >
                {" "}
                Login with credentials
              </h5>
            </div>

            <div className="app-login-form">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.showAuthLoader();
                  this.props.studentSignIn({ email, password });
                }}
              >
                <fieldset>
                  <TextField
                    label={`Matric No. / Email`}
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                    defaultValue={email}
                    margin="normal"
                    type="text"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type={showPassword ? password : "password"}
                    label={<IntlMessages id="appModule.password" />}
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={this.handleChange("password")}
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: "#1E90FF", color: "#ffffff" }}
                    >
                      <IntlMessages id="appModule.signIn" />
                    </Button>

                    <Link to="./ForgotPassword">
                      <IntlMessages id="appModule.retrieveDetails" />
                    </Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  console.log(auth);
  const { loader, alertMessage, showMessage, studentUser } = auth;
  const authUser = studentUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  studentSignIn,
  hideMessage,
  showAuthLoader,
  updateUsermode,
})(StudentSignin);
